/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import {
    bool, func, string,
    object, arrayOf, shape, number,
} from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import mbpLogger from 'mbp-logger';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';

import Loading from '../../../common/Loading';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import configENV from '../../../config';
import { getBrand, getCustomerEmail } from '../../../state/ducks/Common/Common-Selectors';
import AccountLeftMenu from '../../../common/Desktop/AccountLeftMenu';

import DesktopSubscriptionList from './DesktopSubscriptionList';

const { PERSIST_KEY } = configENV;

const styles = (theme) => ({   // eslint-disable-line
    defaultBody: {
        color: '#666',
    },
    subheadText: {
        marginBottom: '20px',
        fontStyle: 'italic',
        color: theme.palette.colorAlert,
    },
});

class DesktopSubscriptions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
        };

        const { customerId, fetchSubscriptions, brand, subscriptions } = props;  // eslint-disable-line object-curly-newline
        fetchSubscriptions(customerId, brand, subscriptions);  // fetch subscriptions into newState
    }

    static getDerivedStateFromError(/* error */) {
        return { hasError: true };
    }

    componentDidMount = () => {
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }
    };

    componentDidCatch = (jsError, reactInfo) => {
        mbpLogger.logError({
            message: `Unhandled Error in DesktopSubscriptions \n jsError = ${jsError} \n reactInfo = ${reactInfo}`,
            module: 'mbp-pwa-ui',
        });
    }

    handleCancelSubscription = (subscriptionRuleId) => {
        const { cancelSubscription, brand } = this.props;
        console.log('subscriptionRuleId', subscriptionRuleId);
        console.log('brand', brand);
        cancelSubscription(subscriptionRuleId, brand);
    }

    render() {
        const { error, hasError } = this.state;   // eslint-disable-line object-curly-newline
        const { isFetchingModal, classes, userProfile, featureFlags } = this.props; // eslint-disable-line object-curly-newline

        if (error || hasError) {
            return <div>Sorry! - we were unable to access your subscriptions.<br />Please try again later.</div>;
        }

        if (isFetchingModal) {
            return <Loading pageTitle="Manage Subscriptions" />;
        }

        const subHead = <div className={classes.subheadText}>Your default card will be used for Subscription orders.</div>;

        return (
            <div className={classes.container}>
                <Grid className="container" container>
                    <AccountLeftMenu
                        userProfile={userProfile}
                        featureFlags={featureFlags}
                    />
                    <Grid item xs={10}>
                        <h2>Your Subscriptions</h2>
                        <Grid container item xs={12}>
                            <div className={classes.defaultBody}>
                                {subHead}
                                <DesktopSubscriptionList handleSelect={this.handleSubscriptionSelectedFromList} handleCancel={this.handleCancelSubscription} />
                            </div>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isFetchingModal: newState.isFetchingModal,
        brand: getBrand(state),
        customerId: getCustomerEmail(state),
        subscriptions: newState.subscriptions,
    };
};

DesktopSubscriptions.defaultProps = {
    fetchSubscriptions: () => { },
    cancelSubscription: () => { },
    subscriptions: [],
    userProfile: {},
    featureFlags: {},
};

DesktopSubscriptions.propTypes = {
    customerId: string.isRequired,
    isFetchingModal: bool.isRequired,
    fetchSubscriptions: func,
    cancelSubscription: func,
    brand: object.isRequired,
    subscriptions: arrayOf(
        shape({
            checkoutBrand: string,
            duration: number.isRequired,
            endDate: string.isRequired,
            interval: number.isRequired,
            nextOrderDate: string,
            orderDate: string.isRequired,
            orderHistoryResult: arrayOf(
                shape({
                    deliveryDate: string,
                    discountAmount: string,
                    orderDate: string.isRequired,
                    orderNumber: string.isRequired,
                    productCode: string.isRequired,
                    productName: string.isRequired,
                    productPrice: string.isRequired,
                    quantity: string.isRequired,
                }),
            ),
            orderNumber: string.isRequired,
            orderTime: string.isRequired,
            orderType: string.isRequired,
            price: string.isRequired,
            productId: string.isRequired,
            productImageCategory: string.isRequired,
            productImageThumbnail: string.isRequired,
            productName: string.isRequired,
            quantity: string,
            recipient: arrayOf(shape({
                city: string.isRequired,
                country: string.isRequired,
                firstName: string.isRequired,
                lastName: string.isRequired,
                state: string.isRequired,
                street1: string.isRequired,
                street2: string.isRequired,
                zipcode: string.isRequired,
            })),
            ruleId: string.isRequired,
            startDate: string.isRequired,
            subscriptionStatus: string.isRequired,
            totalAmount: string.isRequired,
        }),
    ),
    classes: object.isRequired,
    userProfile: shape({
        userRole: string.isRequired,
        email: string.isRequired,
        XAtt4: string.isRequired,
        XAtt5: string.isRequired,
    }),
    featureFlags: object,
};

const mapDispatchToProps = (dispatch) => ({
    fetchSubscriptions: (customerId, brand, subscriptions) => dispatch(EventDispatcher.fetchSubscriptions(customerId, brand, subscriptions)),
    cancelSubscription: (ruleId, brand) => dispatch(EventDispatcher.cancelSubscription(ruleId, brand)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withStyles(styles, { withTheme: true })(DesktopSubscriptions)));
